<form>
    <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Processing... </p></ngx-spinner>
    <div class="card">
        <div class="card-header bg-primary text-left text-white font-weight-bold">
           <span *ngIf="IsRequestReviewed || IsFromApprovedlist"> SPRA Request Review</span>
           <span *ngIf="!IsRequestReviewed"> SPRA Request </span>
            <span class="badge badge-pill bg-light text-primary font-weight-bold" *ngIf="SPRADetail != undefined">
                {{SPRADetail?.RequestNo}} [{{SPRADetail?.OfficeDesc}}]
            </span>
            <!-- <span class="font-weight-bold" *ngIf="SPRADetail != undefined">
                {{SPRADetail?.OfficeDesc}}
            </span> -->
        </div>
        <div class="card-body">

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group row">
                        <div class="col-sm-6">
                            <app-contact-view [RefId]="SpraRequestDetail.RefId"></app-contact-view>
                        </div>
                        <div class="col-sm-6">
                            <app-customer-ageing [paymentAgingParam]="paymentAgingParam"></app-customer-ageing>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-12">
                    
                    
                            <mat-card>
                                <mat-card-title class="font-weight-bold caption-color">SPRA Validity</mat-card-title>
                                <mat-divider></mat-divider>

                                <mat-card-content class="pt-2">

                                  
                                        <div class="row">
                                            <div class="col-sm-6">
                                                
                                                <div class="form-group row text-left">
                                                    <label for="lblSaleType" class="col-sm-4 col-form-label">Sale Type
                                                        <span class="font-red-flamingo">*</span></label>
                                                    <div class="col-sm-8">
            
                                                        <select id="ddlSaleType" name="ddlSaleType"  [disabled]="Mode!='I'" 
                                                            (ngModelChange)="SaleTypeChange()"
                                                            [(ngModel)]="SpraRequestDetail.SaleType" class="form-control">
                                                            <option value="" *ngIf="SpraRequestDetail.SaleType!='LL'">--Select--</option>
                                                            <option value="DD" *ngIf="SpraRequestDetail.SaleType!='LL'">DD</option>
                                                            <option value="DL" *ngIf="SpraRequestDetail.SaleType!='LL'">DL</option>
                                                            <option value="LL" *ngIf="SpraRequestDetail.SaleType=='LL'">LL</option>
                                                        </select>
                                                    </div>
            
                                              
                                            </div>
                                            </div>
                                            
                                            <div class="col-sm-6">
                                                <div class="form-group row text-left">
                                                    <div class="col-sm-4"></div>
                                                    <h4 class="col-sm-8">
                                                        <!-- <span class="badge badge-pill badge-primary" (click)="OpenConsignee()"> Consignee </span> -->
                                                        <span *ngIf="ProfitTag" class="badge badge-pill badge-primary ml-2" (click)="RecalculatePLDetail()"> Recalculate PL </span>
                                                    </h4>
                                        </div>
                                        </div>
                                            <!-- <div class="col-sm-6">                                                
                                                    <div class="form-group row text-left" *ngIf="ProfitTag" >
                                                        <h4 class="col-sm-4">
                                                            <span class="badge badge-pill badge-primary"
                                                                (click)="openOpsList()">Link With OPS</span>
                                                        </h4>
                                                        <div class="col-sm-8" *ngIf="LinkedOps.OpsId != null && LinkedOps.OpsId>0">
                                                            Ops Number : <b> {{LinkedOps.OpsNum !=
                                                                null?LinkedOps.OpsNum:LinkedOps.TempOpsNum}}</b>
                                                            , Ops Date : <b>{{LinkedOps.OpsDate}}</b>
            
                                                        </div>
                                                    </div>
                                            </div> -->
 
                                        </div>
            
                                  

                                        <div class="row">
                                        <div class="col-sm-6">                                                
                                            <div class="form-group row text-left">
                                                <label for="lblSaleType" class="col-sm-4 col-form-label">
                                                    SPRA Period
                                                    <span class="font-red-flamingo">* (In Days)</span></label>
                                                <div class="col-sm-8">
                                                    <!-- [(ngModel)]="SpraNetSalePriceRealisedParams.RebateWoGST" -->
                                                    <input class="form-control" (input)="OnPeriodChange()" type="number"  [(ngModel)]="SpraRequestDetail.Period" name="txtSpraPeriod" >
                                                </div> 
                                        </div>
                                        </div>

                                        <div class="col-sm-6" *ngIf="ProfitTag">                                                
                                            <div class="form-group row text-left">
                                                <label for="lblSaleType" class="col-sm-4 col-form-label">
                                                    Valid Till</label>
                                                <div class="col-sm-8">                                                    
                                                    <input class="form-control" disabled="true" type="text" [(ngModel)]="ValidTill" name="txtValidTill" >                                                   
                                                </div> 
                                        </div>
                                        </div>

                                    </div>


                                </mat-card-content>

                            </mat-card>
                    
                    
                    
                        </div>
                    </div>




                    <!-- <div class="form-group row">
                        <div class="col-sm-6">
                            <app-contact-consignee  #ContactBilling  [contactConsigneeParams]="contactBillingParams"
                                (changeConsignee)="changeConsignee($event)"></app-contact-consignee>
                        </div>
                        <div class="col-sm-6">
                            <app-contact-consignee #ContactConsignee [contactConsigneeParams]="contactConsigneeParams"
                                (changeConsignee)="changeConsignee($event)"></app-contact-consignee>
                        </div>
                    </div> -->
                    <!-- <div class="form-group row">
                        <div class="col-sm-12">
                            <app-ops-details (changeOpsDetail)="changeOpsDetail($event)"></app-ops-details>
                        </div>
                    </div> -->
                  <!-- Added By rahul yadav on 27/05/2021 for discount view -->
                  <div class="form-group row" *ngIf="ProfitTag">
                    <div class="col-sm-12">
                        <app-spra-discount-view></app-spra-discount-view>
                    </div>
                </div>
                     
                    <div class="form-group row">
                        <div class="col-sm-12">
                            <app-ops-part-serach (ChangeOpsPartSerach)="ChangeOpsPartSerach($event)"
                                (ChangeCounterList)="ChangeCounterList($event)" (SpraHaveFinishGood)="SpraHaveFinishGood($event)" (ProductValueChanged)="ProductValueChanged($event)" (GetFGProduct)="GetFGProduct($event)"  ></app-ops-part-serach>
                        </div>
                    </div>
                    <!-- Added By rahul yadav on 30/05/2021 for consignee -->
                    <div class="form-group row">
                        <div class="col-sm-12" *ngIf="ProfitTag && IsSpraHaveFinishGood && SpraRequestDetail.SaleType!='LL'">
                           <app-spra-view-consignee></app-spra-view-consignee>
                       </div>
                    </div>
                    
                    <div class="form-group row">
                        <div class="col-sm-12">
                            <app-ops-payment-terms></app-ops-payment-terms>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-12">
                            <app-spra-approval (ChangeSpraApproval)="ChangeSpraApproval($event)"
                                (ChkDayOneCSA)="ChkDayOneCSA($event)"  ></app-spra-approval>
                        </div>
                    </div>
                    <!-- Removed by rajan singh on 17/06/2021 -- after discussion with Mr. anand -->
                    <!-- *ngIf="SpraRequestDetail.SaleType!='LL'" --> 
                    <div class="form-group row" >
                        <div class="col-sm-12">
                            <app-spra-amcv (BindCsaUnitPrice)="BindCsaUnitPrice($event)" (GetAMCVTotalValues)="GetAMCVTotalValues($event)"></app-spra-amcv>
                        </div>
                    </div>

                    <div class="form-group row" *ngIf="SpraRequestDetail.SaleType!='LL'">
                        <div class="col-sm-12">
                            <app-spra-net-sale-price-realised (DealerChange)="DealerChange($event)"></app-spra-net-sale-price-realised>
                        </div>
                    </div>
                   
                   

                    <div class="form-group row" *ngIf="IsSpraHaveFinishGood">
                        <div class="col-sm-12">
                            <app-spra-competition-detail></app-spra-competition-detail>
                        </div>
                    </div>
                    
                    <div class="form-group row" *ngIf="SpraRequestDetail.SaleType!='DD' && ProfitTag ">
                        <div class="col-sm-12">
                            <app-spra-consumable-billing-detail></app-spra-consumable-billing-detail>
                        </div>
                    </div>
                   


                    <div class="form-group row" >
                        <div class="col-sm-6" *ngIf="Mode=='I'">
                            <app-spra-price-justification></app-spra-price-justification>
                        </div>
                        <div class="col-sm-6">
                        
                            <mat-card>
                                <mat-card-title class="font-weight-bold caption-color">Upload Documents <span class="font-red-flamingo">[PDF]</span>
                                </mat-card-title>
                                <mat-divider></mat-divider>
                                <mat-card-content class="pt-2 ">                        
                                    <app-multiple-file-upload></app-multiple-file-upload>
                                </mat-card-content>
                            </mat-card>
                        
                        </div>
                    </div>
                   
                 

                    <div class="form-group row" *ngIf="Mode=='U'">
                        <div class="col-sm-12">
                            <app-spra-approval-remarks></app-spra-approval-remarks>
                        </div>
                     
                    </div>
                   


                </div>
            </div>

        </div>
        <div class="card-footer text-left">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8 pl-4">
                            <!-- <button *ngIf="ShowReviewButton" class="btn btn-primary" [disabled]="DisableSubmit"  (click)="ReviewSPRA()">Review</button>
                            &nbsp;&nbsp; -->
                            <button class="btn btn-primary" [disabled]="DisableSubmit"  (click)="SpraSubmit()">Submit</button>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>

</form>


